<scrm-modal [closable]="true"
            [close]="closeButton"
            [titleKey]="'LBL_EXPORT'"
            class="export-excel"
            klass="">

    <div modal-body>
        <ng-content *ngIf="fields$ | async as fields">
            <div class="container-fluid">
                <form (ngSubmit)="submitClick();" class="row">
                    <div *ngFor="let field of fields" class="col-4">
                        <div class="col-12 inline d-flex">
                            <div class="col-10">
                                <ng-container *ngIf="field.label === ''; else rawLabel">
                                    <scrm-label [labelKey]="field.labelKey"></scrm-label>
                                </ng-container>

                                <ng-template #rawLabel>
                                    {{field.label}}
                                </ng-template>
                            </div>
                            <div class="col-2">
                                <scrm-field [field]="field"
                                    [klass]=""
                                    [mode]="'edit'"
                                    [record]="record"
                                    [type]="field.type">
                                </scrm-field>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </ng-content>
    </div>

    <div modal-footer>
        <div *ngIf="!loading" class="row">
            <div class="col d-flex">
                <ng-container *ngIf="selectExportTypeField">
                    <scrm-label [labelKey]="selectExportTypeField.labelKey"></scrm-label>
                    <scrm-enum-edit [field]="selectExportTypeField"></scrm-enum-edit>
                </ng-container>
            </div>
            <div class="col modal-buttons" *ngIf="buttons.length > 0">
                <ng-container *ngFor="let button of buttons" [ngSwitch]="button.type">
                    <scrm-button *ngSwitchDefault [config]="button"></scrm-button>
                </ng-container>
            </div>
        </div>
    </div>

</scrm-modal>

